"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEEDBACK = void 0;
const client_1 = require("@apollo/client");
exports.FEEDBACK = (0, client_1.gql) `
  query Feedback($productIds: [Int]) {
    feedback(productIds: $productIds) {
      id
      name
      feedback
      university
      productId
      product {
        id
        name
      }
    }
  }
`;
